<div class="login-area">
  <div class="login-container element-column">
    <img class="logo" alt="logo" src="/assets/img/peace_logo_yoko.png" />

    <div class="login-content">
      <div class="login-detail">
        <label>
          PEACEのウィンドウが開かない場合は、ブラウザのポップアップブロックを解除してください。<br>
          再度表示したい場合は<a (click)="eventPeaceOpenHandler()" class="peace-open">こちら</a>をクリックしてください。
        </label>
      </div>
    </div>
  </div>
</div>